<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.data)">
        <span>{{ organizationTypeString(params.data) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: 'CellRendererType',
    computed: {
        chipColor() {
            return value => {
                if (value.type === 0) {
                    return "danger"
                } else if (value.type === 1) {
                    return "success"
                }
            }
        },
        organizationTypeString() {
            return value => {
                if (value.type === 0) {
                    return this.$t('invoice.student')
                } else if (value.type === 1) {
                    return this.$t('invoice.school')
                }


            }
        }
    }
}
</script>

<style lang="scss" scpoped>
</style>
